<script lang="ts">
  import { locale, _ } from 'svelte-i18n';
  import { availableLocales, localeNames, changeLocale, resetI18nInitialization, type LocaleCode } from '$lib/i18n';
  import { Globe } from 'lucide-svelte';
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  
  let isOpen = false;
  let dropdownRef: HTMLDivElement;
  let currentLocale = '';
  
  // ロケール変更を監視
  locale.subscribe(value => {
    console.log('Current locale in LanguageSwitcher:', value);
    currentLocale = value || 'ja';
  });
  
  // 言語切り替え関数
  function handleChangeLanguage(newLocale: string) {
    console.log(`Changing language from ${currentLocale} to ${newLocale}`);
    // 初期化フラグをリセット
    resetI18nInitialization();
    // 言語を変更（changeLocale関数内でページリロードを行う）
    changeLocale(newLocale);
    isOpen = false;
  }
  
  // 外部クリックでドロップダウンを閉じる
  function handleClickOutside(event: MouseEvent) {
    if (dropdownRef && !dropdownRef.contains(event.target as Node)) {
      isOpen = false;
    }
  }
  
  onMount(() => {
    document.addEventListener('click', handleClickOutside);
    console.log('LanguageSwitcher mounted, currentLocale:', $locale);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>

<div class="relative" bind:this={dropdownRef}>
  <button
    class="p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-colors duration-300 flex items-center"
    on:click={() => isOpen = !isOpen}
    aria-label={$_('language.select')}
  >
    <Globe size={20} />
  </button>
  
  {#if isOpen}
    <div
      class="absolute right-0 mt-2 w-48 bg-white dark:bg-zinc-800 rounded-lg shadow-lg overflow-hidden z-50 border border-gray-200 dark:border-gray-700"
      transition:fade={{ duration: 150 }}
    >
      <div class="px-4 py-2 text-xs text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
        {$_('language.select')}
      </div>
      
      <div class="max-h-60 overflow-y-auto">
        {#each availableLocales as localeCode (localeCode)}
          <button
            class="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-between {$locale === localeCode ? 'bg-gray-100 dark:bg-gray-700' : ''}"
            on:click={() => handleChangeLanguage(localeCode)}
          >
            <span class="text-gray-900 dark:text-white">
              {#if localeCode === 'ja' || localeCode === 'en' || localeCode === 'zh-TW' || localeCode === 'ko'}
                {localeNames[localeCode]}
              {:else}
                {localeCode}
              {/if}
            </span>
            {#if $locale === localeCode}
              <span class="text-green-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
            {/if}
          </button>
        {/each}
      </div>
    </div>
  {/if}
</div>

<style>
  /* スタイルが必要な場合はここに追加 */
</style>